/*
 * Ponto único de entrada dos tokens. A ordem importa: base define os valores,
 * semântico dá papel a eles, marca sobrescreve só o acento.
 */
@import './base.css';
@import './semantico.css';
@import './marcas.css';
@import './breakpoints.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  /* Respeita o tamanho de fonte escolhido pelo usuário no navegador —
     `px` fixo aqui é o que quebra o zoom de 400% exigido por UI-03. */
  font-size: 100%;
}

body {
  margin: 0;
  min-width: 320px;
  font-family: var(--fonte-base);
  font-size: var(--texto-md);
  line-height: var(--altura-linha);
  color: var(--texto);
  background: var(--superficie);
  -webkit-font-smoothing: antialiased;
}

/* Foco sempre visível, e com contraste também no escuro (A11Y-03). */
:focus-visible {
  outline: 2px solid var(--foco);
  outline-offset: 2px;
  border-radius: var(--raio-sm);
}

/* A11Y-08: nada de movimento para quem pediu para não ter. */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* Conteúdo lido por leitor de tela, invisível na tela. */
.apenas-leitor {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
